import React, { memo } from 'react'

import SubSection from './sub-section'

let tabIndex = 0;
const SubSections = memo(({ subSections = [], onSectionClick }) =>
  subSections.map(
    (subSection, index) =>
      subSection.featureEnabled &&
      subSection.hasElmoTreatment && (
        <SubSection
          tabIndex={tabIndex++}
          key={`subSection-${index}`}
          {...subSection}
          iconMiddle
          onSectionClick={onSectionClick}
        />
      ),
  ),
)
SubSections.displayName = 'SubSections'
export default SubSections
